import { SimplePlayer } from '../../simple-player';
import { ApiPostRequest } from './api-post-request';

export class PlayerCreateRequest extends ApiPostRequest
{
    public constructor(player: SimplePlayer, webapiBasepath: string)
    {
        super('player/create', null, null, player, webapiBasepath);
    }
}
